import {
  refreshCategoryItems,
  loadContentPrivateBlog,
} from './thunk';

import type { PrivateBlogCategoryJson } from '@/types/domain/privateBlog/entities/privateBlogCategoryEntity';
import type { PrivateBlogJson } from '@/types/domain/privateBlog/entities/privateBlogEntity';
import type { CategoryItemsType } from '@/types/domain/privateBlog/redux';
import type { Dispatch } from 'redux';

/**
 * React component初期化関数.
 * @param dispatch dispatch
 */
export const init = (
  dispatch: Dispatch<any>,
  nurseryId: string | undefined,
  _isInitCategoryItems: boolean,
) => {
  if (nurseryId) {
    // 開くたびにrefreshを実行する
    dispatch(refreshCategoryItems({ nurseryId }));
  }
};

/**
 * PrivateBlogController
 */
export class PrivateBlogController {
  private dispatch: Dispatch<any>;

  private nurseryId: string;

  private categoryList: PrivateBlogCategoryJson[] = [];

  private categoryItems: CategoryItemsType;

  constructor(
    dispatch: Dispatch<any>,
    nurseryId: string,
    categoryList: PrivateBlogCategoryJson[],
    categoryItems: CategoryItemsType,
  ) {
    this.dispatch = dispatch;
    this.nurseryId = nurseryId;
    this.categoryList = categoryList;
    this.categoryItems = categoryItems;
  }

  /**
   * カテゴリ取得
   * @returns カテゴリ
   */
  getCategories = () => [...this.categoryList]
    .sort((a, b) => (a.categoryIndex > b.categoryIndex ? 1 : -1));

  /**
   * ページ取得
   * @param categoryJson カテゴリ
   * @returns ページ
   */
  getPages = (categoryJson: PrivateBlogCategoryJson) => {
    const { categoryId } = categoryJson;
    const { items } = this.categoryItems[categoryId];
    return items;
  };

  /**
   * 詳細アクションを取得
   * @param setDetailPrivateBlogJson setDetailPrivateBlogJson
   * @returns アクション
   */
  getActionDetail(
    setDetailPrivateBlogJson:
      (value: PrivateBlogJson | undefined) => void,
  ) {
    return (data: PrivateBlogJson | undefined) => {
      if (data) {
        this.dispatch(loadContentPrivateBlog({ data, nurseryId: this.nurseryId }));
        setDetailPrivateBlogJson(data);
      } else {
        this.dispatch(loadContentPrivateBlog({ data: undefined, nurseryId: this.nurseryId }));
        setDetailPrivateBlogJson(undefined);
      }
    };
  }
}
